<template>
  <div
    class="wt2-sg wt2-masthead-info-icon"
    :title="title"
    :class="{ '-active': getActionPanelOpenStatus }"
    @click="toggleActionPanel"
  >
    <i class="wticon wticon-information1"></i>
  </div>
</template>

<script>
import app from 'app';

export default {
  name: 'MastheadInfoIcon',
  props: {
    title: {
      type: String,
      default: app.culture.producing.infoTooltip,
    },
  },
  computed: {
    getActionPanelOpenStatus() {
      return this.$store.getters.getActionPanelOpenStatus;
    },
  },

  methods: Object.assign({}, app.Vuex.mapMutations(['toggleActionPanel'])),
};
</script>
